module.exports = __webpack_public_path__ + "img/7.87daa240.jpeg";